export default __webpack_public_path__ + "static/media/Thrór's Map - Img - Final (2)_04.f2cdf7b8.jpg";